import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Chris Glasman
        </p>
        <a
          className="App-link"
          href="https://cloudflare.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered by Cloudflare
        </a>
      </header>
    </div>
  );
}

export default App;
